import {BaseConfig} from "../../infrastructure/config/base-config";
import {PredictionsWidgetTerms} from "./predictions-widget.terms";
import {APP} from "../../core/app/consts";

export class PredictionsWidgetConfig extends BaseConfig {
  source: APP.ANALYTICS.SOURCES;

  static injectables = [PredictionsWidgetTerms];

  constructor(terms: PredictionsWidgetTerms) {
    super('predictionsWidget', null, terms);

    this.source = APP.ANALYTICS.SOURCES.predictions;
  }
}
